import tw from 'tailwind-styled-components'

type TrProps = {$isBold?: boolean}
export const Row = tw.tr<TrProps>`
  flex
  p-8
  odd:bg-main-even-old
  rounded-4
  leading-3
  text-secondary-old
  ${p => (p.$isBold ? 'font-semibold' : '')}
`

export const Required = tw.span`
  text-error-old
`

const ColumnBase = tw.td`
  flex
  grow-0
  shrink-0
`

export const ColumnName = tw(ColumnBase)`
  w-100
  font-semibold
`

export const ColumnType = tw(ColumnBase)`
  w-60
`

export const ColumnStatus = tw(ColumnBase)`
  w-110
`

export const ColumnDescription = tw(ColumnBase)`
  flex
  grow-1
  shrink-0
  tracking-tight
`

export const TextSecondary = tw.span`
  text-secondary-old
`
